import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

let cancelTokens = {};

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "trakers",
    object: "traker",
    header: [
      { text: "Spot destino", value: "spot" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions,
    getList({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");
        const randomText = Array(10).fill(null).map(() => String.fromCharCode(97 + Math.floor(Math.random() * 26))).join("");
        for (let key in cancelTokens) {
          if(cancelTokens[key])
            cancelTokens[key].cancel("Cancelled previous request");
        }
        cancelTokens[randomText] = axios.CancelToken.source();

        let filter = {
          search: "",
          limit: 10,
          page: 1,
        };

        if (options) {
          for (let i in options) filter[i] = options[i];
          commit("options", options);
          filter.limit = options.itemsPerPage === -1 ? state.total : options.itemsPerPage;
          filter.page = options.page;
          filter.search = options.search;
          filter.sorting_column = options.sortBy.length > 0 ? options.sortBy[0] : "";
          filter.sorting_order = options.sortDesc.length > 0 ? (options.sortDesc[0] ? "asc" : "desc") : "";
        }
        axios
          .get(config.api_url + state.endpoint, {
            params: filter,
            cancelToken: cancelTokens[randomText].token,
          })
          .then((response) => {
            commit("success", {
              list: response.data,
              total: parseInt(response.headers["pagination-count"]),
            });
            resolve(response.data);
          })
          .catch((err) => {
            if (axios.isCancel(err)) return;
            commit("error");
            reject(err);
          })
          .finally(() => {
            delete cancelTokens[randomText];
          });
      });
    },
  },
  getters: {
    ...genericStore.getters
  }
};
